import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/components'

import Vant from 'vant'
import 'vant/lib/index.css'

import '@/style/index.scss'
import Vconsole from 'vconsole'
if (process.env.NODE_ENV === 'development') {
  // new Vconsole()
}

// new Vconsole()

Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app')
